export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="10" fill="#0E1526" stroke="rgba(212,175,55,0.4)" />
    <g fill="none" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round">
      <line x1="32" y1="12" x2="32" y2="46" />
      <line x1="14" y1="20" x2="50" y2="20" />
      <line x1="24" y1="52" x2="40" y2="52" />
      <path d="M14 20 L8 34 M14 20 L20 34" strokeWidth="2" />
      <path d="M8 34 Q14 40 20 34" strokeWidth="2.5" />
      <path d="M50 20 L44 34 M50 20 L56 34" strokeWidth="2" />
      <path d="M44 34 Q50 40 56 34" strokeWidth="2.5" />
    </g>
    <circle cx="32" cy="12" r="3" fill="#D4AF37" />
  </svg>
);

export const LogoWordmark = () => (
  <div className="leading-none" data-testid="nav-logo">
    <span className="block font-display text-lg sm:text-xl font-bold tracking-wide text-slate-50">
      HEIDARI <span className="text-gold">LAW GROUP</span>
    </span>
    <span className="mt-1 block font-mono text-[10px] tracking-[0.3em] text-gold/70 uppercase">
      Trial Attorneys · Est. Los Angeles
    </span>
  </div>
);
